import api from "../../../api/api";

/* ===============================
   GET – Dashboard Counts
=============================== */
export const getDashboardCounts = () => {
  return api.get("/crm/v1/dashboard/counts/");
};

export const getUserVerticalCounts = (params: {
    owner_id: number;
    vertical: number;
}) => {
    return api.get("/crm/v1/dashboard/counts/", {
        params,
    });
};